import { render } from "./EditClientHierarchy.vue?vue&type=template&id=5f242a48"
import script from "./EditClientHierarchy.vue?vue&type=script&lang=js"
export * from "./EditClientHierarchy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__